import { render, staticRenderFns } from "./public-shipment-layout.vue?vue&type=template&id=0ec026a0&scoped=true"
import script from "./public-shipment-layout.vue?vue&type=script&lang=js"
export * from "./public-shipment-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec026a0",
  null
  
)

export default component.exports